//@ts-ignore
// Ignored because on mobile not is used the import.meta.env

export const BACKEND_URL =
  process.env.VITE_BACKEND_URL || import.meta.env?.VITE_BACKEND_URL || "";
export const POLICY_URL =
  process.env.VITE_POLICY_URL || import.meta.env?.VITE_POLICY_URL || "";

export const FACE_URL =
  process.env.VITE_FACE_URL || import.meta.env?.VITE_FACE_URL || "";
export const DOCUMENT_URL =
  process.env.VITE_DOCUMENT_URL || import.meta.env?.VITE_DOCUMENT_URL || "";

export const NEW_API_URL =
  process.env.VITE_NEW_API_URL || import.meta.env?.VITE_NEW_API_URL || "";

export const WAYUP_API_URL =
  process.env.VITE_WAYUP_API_URL || import.meta.env?.VITE_WAYUP_API_URL || "";

export const ENVIRONMENT =
  process.env.VITE_ENVIRONMENT || import.meta.env?.VITE_ENVIRONMENT || "";

export const UNICO_CALLBACK_URL =
  import.meta.env?.VITE_UNICO_CALLBACK_URL ||
  process.env.VITE_UNICO_CALLBACK_URL ||
  "";
